// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1z-qD","col":"styles_col__1I4h3"};